import React, { useRef, useCallback, useState } from 'react';

import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import { Button, Row, Col } from 'react-bootstrap';
import { useToast } from '../../../hooks/toast';

import Loading from '../../../components/Loading';
import Input from '../../../components/Input';
import getValidationErrors from '../../../utils/getValidationErrors';

import api from '../../../services/api';
import getResponseErrors from '../../../utils/getResponseErrors';
import { IPalavraBloqueada } from '..';

type Props = {
  palavra?: IPalavraBloqueada;
  setShowModal(value: boolean): void;
};

const PalavraBloqueadaCadastro: React.FC<Props> = ({
  palavra,
  setShowModal,
}) => {
  const { addToast } = useToast();
  const [id, setId] = useState<number | undefined>(
    palavra ? palavra.id : undefined,
  );

  const formRefModelo = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmitPalavra = useCallback(
    async (dados: IPalavraBloqueada) => {
      try {
        setLoading(true);
        formRefModelo.current?.setErrors({});
        const schema = Yup.object().shape({
          palavra: Yup.string()
            .min(3, 'Mínimo 3 caracteres')
            .required('Palavra é obrigatório'),
        });

        const modeloForm = {
          ...dados,
        };

        await schema.validate(modeloForm, {
          abortEarly: false,
        });

        const dadosPalavra = {
          ...modeloForm,
        };

        if (id) {
          await api.put<IPalavraBloqueada>(
            `/palavraBloqueada/${id}`,
            dadosPalavra,
          );
        } else {
          await api.post<IPalavraBloqueada>('/palavraBloqueada', dadosPalavra);
        }
        setShowModal(false);
        addToast({ title: 'Palavra salva', type: 'success' });
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRefModelo.current?.setErrors(errors);
          return;
        }

        const mensagem = getResponseErrors(error);
        addToast({
          type: 'error',
          title: 'Erro ao salvar Palavra',
          description: mensagem,
        });
      } finally {
        setLoading(false);
      }
    },
    [addToast, id, setShowModal],
  );

  return (
    <div className="container">
      {loading && <Loading />}

      <Row noGutters>
        <Col md={12}>
          <Form
            ref={formRefModelo}
            initialData={{
              ...palavra,
            }}
            onSubmit={handleSubmitPalavra}
          >
            <Row>
              <Col md={10} className="form-group pr-2">
                <Input
                  name="palavra"
                  label="Palavra Bloqueada"
                  maxLength={15}
                />
              </Col>

              <Col md={2} className="form-group pr-2">
                <Button type="submit" variant="success" className="mt-2">
                  Salvar
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default PalavraBloqueadaCadastro;
